import Phaser from 'phaser';
import SpritePool from '../common/SpritePool';
import SomeSprite from '../game/SomeSprite';
import SomeBitmapMoving from '../game/SomeBitmapMoving';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import ScoopsView from './scoops/ScoopsView';
import SauceView from './sauce/SauceView';
import WhippedCreamView from './whippedcream/WhippedCreamView';
import ToppingsView from './toppings/ToppingsView';
import { resizeDimensions, snapshot, trimCanvas } from '../Utils';
import IceCreamData from '../IceCreamData';
import SoundAssetKeys from '../SoundAssetKeys';

export default class WorkArea extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,areaX, areaY) {
    super(scene);
    this.name = 'WorkArea';

    this.containerFixedY = 150;
    this.areaX = areaX;
    this.areaY = areaY;

    this.menuSound = 1;

    this.tmpImg = null;

    this.sundaeInfo = {
      container: -1,
      containerIsDish: false,
      scoops: [],
      sauces: [],
      whippedCreams: [],
      toppings: []
    };
    this.sundaePosition = {
      top: 0,
      yOffset: 0
    };

    this.tossOutSpeed = 620;

    this.workingCategory = 'Container';

    this.extraSpritePool = new SpritePool(SomeSprite, 50, this.scene);

    /** @type {SomeSprite[]} */
    this.extraActiveSprites = [];

    this.extraBitmapPool = new SpritePool(SomeBitmapMoving, 20, this.scene);

    /** @type {SomeBitmapMoving[]} */
    this.extraActiveBitmaps = [];

    const viewStroke = 8;
    this.bg = this.scene.add.graphics({ fillStyle: { color: 0xeddcf7 }, lineStyle: { width: viewStroke, color: 0xcb9aed } });
    this.bgWidth = 715;
    this.bgHeight = 554;
    this.bg.fillRoundedRect(0,0,this.bgWidth, this.bgHeight, 12);
    this.bg.strokeRoundedRect(0,0,this.bgWidth, this.bgHeight, 12);

    this.bg.x = this.areaX;
    this.bg.y = this.areaY + viewStroke;

    this.bg.setInteractive(new Phaser.Geom.Rectangle(0,0,this.bgWidth, this.bgHeight), Phaser.Geom.Rectangle.Contains);
    this.bg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.bgMousedown, this);

    this.add(this.bg);
    this.bg.alpha = 0;

    this.workAreaPostions = {
      centerX: this.bg.x + this.bgWidth / 2,
      centerY: this.bg.y + this.bgHeight / 2,
      bottom: this.bg.y + this.bgHeight,
      top: this.bg.y,
      left: this.bg.x,
      right: this.bg.x + this.bgWidth
    };
    this.workAreaPostions.width = this.workAreaPostions.right - this.workAreaPostions.left;
    this.workAreaPostions.height = this.workAreaPostions.bottom - this.workAreaPostions.top;

    const w = this.bgWidth - viewStroke;
    const h = this.bgHeight - viewStroke;
    this.viewArea = this.scene.add.container();
    this.viewArea.name = 'ViewArea';
    this.viewMask = this.scene.add.graphics({ fillStyle: { color: 0xcccccc } }).setVisible(false);
    this.viewMask.fillRoundedRect(this.bg.x + viewStroke * 0.5, this.bg.y + viewStroke * 0.5, w, h, 12);

    this.viewArea.mask = new Phaser.Display.Masks.GeometryMask(this.scene, this.viewMask);

    this.add(this.viewArea);

    this.trashContainer = this.scene.add.container();
    this.trashContainer.name = 'TrashContainer';

    this.trashContainer.x = this.workAreaPostions.centerX;
    this.trashContainer.y = this.scene.scale.height / 2;

    this.trashContainer.setPosition(this.trashContainer.x - this.workAreaPostions.centerX, this.trashContainer.y - this.scene.scale.height / 2);

    this.itemContainer = this.scene.add.container();
    this.itemContainer.name = 'ItemContainer';

    this.itemContainer.x = this.workAreaPostions.centerX;
    this.itemContainer.y = this.scene.scale.height / 2;

    this.itemContainer.setPosition(this.itemContainer.x - this.workAreaPostions.centerX, this.itemContainer.y - this.scene.scale.height / 2);

    this.containerSprite = ABCyaPhaser.Images.addImage(this.workAreaPostions.centerX, this.workAreaPostions.bottom, UIAssetKeys._Container_1,this.itemContainer);
    this.containerSprite.y += this.containerSprite.height;

    this.scoopsView = new ScoopsView(this.scene, this, this.itemContainer, this.sundaeInfo);
    this.sauceView = new SauceView(this.scene, this, this.workAreaPostions);
    this.whippedCream = new WhippedCreamView(this.scene, this, this.workAreaPostions);
    this.toppings = new ToppingsView(this.scene, this, this.itemContainer, this.sundaeInfo);

    this.viewArea.add([this.trashContainer, this.itemContainer]);
    this.itemContainer.bringToTop(this.containerSprite);
    this.scoopContainers = new SpritePool(Phaser.GameObjects.Container, 3, this.scene);

    // hack on some levels in each scoop
    for (let i = 0; i < this.scoopContainers.pool.length; i++) {
      const c1 = new Phaser.GameObjects.Container(this.scene);
      c1.name = 'Sauce Layer';
      const c2 = new Phaser.GameObjects.Container(this.scene);
      c2.name = 'Cream/Toppings Layer';
      this.scoopContainers.pool[i].sauceLayer = c1;
      this.scoopContainers.pool[i].toppingsLayer = c2;
      this.scoopContainers.pool[i].add(c1);// sauce
      this.scoopContainers.pool[i].add(c2);// cream+toppings
    }
    this.currentScoopContainers = [];

    this.toppingThrowContainer = new Phaser.GameObjects.Container(this.scene);
    this.toppingThrowContainer.name = 'ToppingThrowContainer';

    this.viewArea.add(this.sauceView);
    this.viewArea.add(this.whippedCream);
  }

  bgMousedown (pointer) {
    if (this.workingCategory === 'Toppings') {
      this.addToppings(pointer.x, pointer.y);
    }
    else {
      console.log('no toppings');
    }
  }

  addToppings (x,y) {
    this.toppings.moreToppings(x,y);
  }

  resetEverything () {
    this.removeCurrentCategoryItems();
    const prevContainer = this.sundaeInfo.container;
    if (prevContainer) {
      this.tossOutItem(this.containerSprite);
      this.containerSprite.y = this.scene.scale.height * 2;
    }
    this.scoopsView.wipeScoops();
    this.sundaeInfo.container = -1;
    this.scene.tweens.killTweensOf(this.itemContainer);
    this.workingScale = 1.0;
    this.itemContainer.scale = this.workingScale;

    this.itemContainer.x = 0;
    this.itemContainer.y = 0;
    this.sundaePosition.yOffset = 0;
    this.sundaePosition.top = 0;

    this.sauceView.sauce.sauceDisplayCanvas.clear();
  }

  removeCurrentCategoryItems () {
    if (this.workingCategory === 'Sauce') {
      this.saveCurrentSauce();
      this.sauceView.doOutro();
    }
    else if (this.workingCategory === 'Whipped Cream') {
      this.whippedCream.doOutro();
    }
  }

  saveCurrentSauce () {
    const sauceBmp = this.sauceView.getCurrentSauceImage();
    if (sauceBmp) {
      sauceBmp.y -= this.sundaePosition.yOffset;

      this.addSauceToTopScoop(sauceBmp);
    }
  }

  addSauceToTopScoop (item) {
    if (this.sundaeInfo.scoops.length <= 0) return;
    const theScoop = this.sundaeInfo.scoops[this.sundaeInfo.scoops.length - 1];

    this.topScoopContainer.sauceLayer.addAt(item, this.topScoopContainer.sauceLayer.length - 1);
    this.topScoopContainer.add([this.topScoopContainer.sauceLayer,this.topScoopContainer.toppingsLayer]);
    this.topScoopContainer.bringToTop(this.topScoopContainer.sauceLayer);
    this.topScoopContainer.bringToTop(this.topScoopContainer.toppingsLayer);

    if (this.sundaeInfo.containerIsDish) {
      this.topScoopContainer.add(this.containerSprite);
      this.topScoopContainer.bringToTop(this.containerSprite);
    }

    // eslint-disable-next-line no-param-reassign
    item.toppingType = 'sauce';
    theScoop.toppingStuff.push(item);
  }

  addWhippedCreamDab (item) {
    if (this.sundaeInfo.scoops.length <= 0) return;
    const theScoop = this.sundaeInfo.scoops[this.sundaeInfo.scoops.length - 1];
    // eslint-disable-next-line no-param-reassign
    item.toppingType = 'cream';

    this.topScoopContainer.toppingsLayer.add(item);
    this.topScoopContainer.add([this.topScoopContainer.sauceLayer,this.topScoopContainer.toppingsLayer]);
    this.topScoopContainer.bringToTop(this.topScoopContainer.sauceLayer);
    this.topScoopContainer.bringToTop(this.topScoopContainer.toppingsLayer);

    if (this.sundaeInfo.containerIsDish) {
      this.topScoopContainer.add(this.containerSprite);
      this.topScoopContainer.bringToTop(this.containerSprite);
    }

    theScoop.toppingStuff.push(item);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} oldSprite 
   * @param {*} speed 
   */
  tossOutItem (oldSprite, speed = this.tossOutSpeed) {
    /** @type {SomeSprite} */
    const newSprite = this.extraSpritePool.getSprite();
    const vx = 0;
    const vy = speed;
    const lifetime = 3;
    const destX = null;
    const destY = this.scene.scale.height;
    if (newSprite) {
      const framename = oldSprite.frame.name;
      newSprite.reset(oldSprite.x, oldSprite.y, vx, vy, framename, oldSprite.alpha, oldSprite.angle, oldSprite.scaleX, oldSprite.scaleY, oldSprite.originX, oldSprite.originY, lifetime, destX, destY);
      this.extraActiveSprites.push(newSprite);
      this.trashContainer.add(newSprite);
    }
    else {
      console.error('No new sprites left');
    }
  }

  tossOutTopping (item, speed) {
    if (item.toppingType === 'sauce') {
      this.tossOutImage(item, speed);
    }
    else if (item.toppingType === 'cream') {
      this.tossOutImage(item, speed);
    }
    else if (item.toppingType === 'topping') {
      this.tossOutItem(item, speed);
    }
    else {
      console.error('error tossing out...');
    }
  }

  tossOutImage (img, speed = this.tossOutSpeed) {
    const vx = 0;
    const vy = speed;
    const lifetime = 3;
    const destX = null;
    const destY = this.scene.scale.height;

    /** @type {SomeBitmapMoving} */
    const newimg = this.extraBitmapPool.getSprite();
    newimg.reset(img, vx, vy, lifetime, destX, destY);
    this.trashContainer.add(newimg.bmp);
    this.extraActiveBitmaps.push(newimg);
  }

  removeScoopLayer (scoop) {
    /** @type {Phaser.GameObjects.Container} */
    const p = scoop.parentContainer;

    if (p.exists(p.sauceLayer)) p.remove(p.sauceLayer);
    if (p.exists(p.toppingsLayer)) p.remove(p.toppingsLayer);
    p.remove(scoop);
    this.scene.children.remove(scoop);
    this.itemContainer.add(this.containerSprite);
    p.removeAll(true);
    if (p.sauceLayer.exists(this.sauceView.sauce)) p.sauceLayer.remove(this.sauceView.sauce);
    this.scene.children.remove(this.sauceView.sauce);
    p.sauceLayer.removeAll(true);

    p.toppingsLayer.removeAll(true);
    const index = this.currentScoopContainers.indexOf(p);
    this.currentScoopContainers.splice(index,1);
    this.scoopContainers.returnSprite(p);
    this.itemContainer.remove(p);
  }

  async getCurrentCreationNewImage (maxWidth = 0, maxHeight = 0) {
    return new Promise((resolve, reject) => {
      this.whippedCream.updateWhippedCream();

      const topBuffer = 135;

      let scale = 1;

      if (maxWidth > 0 || maxHeight > 0) {
      // eslint-disable-next-line no-param-reassign
        if (maxWidth <= 0) maxWidth = this.workAreaPostions.width;
        // eslint-disable-next-line no-param-reassign
        if (maxHeight <= 0) maxHeight = this.containerSprite.y + this.containerSprite.height / 2 + topBuffer;
        const newDims = resizeDimensions(this.workAreaPostions.width, this.containerSprite.y + this.containerSprite.height / 2 + topBuffer, maxWidth, maxHeight);
        scale = newDims.scale;
      }

      if (this.scene.textures.exists('trimmed')) this.scene.textures.remove('trimmed');

      const originalScale = this.itemContainer.scale;
      const itemContainerRt = new Phaser.GameObjects.RenderTexture(this.scene, 0,0,Math.ceil(this.workAreaPostions.width * scale),Math.ceil((this.containerSprite.y + this.containerSprite.height / 2 + topBuffer) * scale));
      itemContainerRt.draw(this.itemContainer.setScale(scale), -(this.workAreaPostions.left * scale),-(this.workAreaPostions.top - topBuffer) * scale);

      this.itemContainer.setScale(originalScale);

      snapshot.apply(itemContainerRt, [(image) => {
        const collisionCanvas = document.createElement('canvas');
        collisionCanvas.width = itemContainerRt.width;
        collisionCanvas.height = itemContainerRt.height;
        const collisionCtx = collisionCanvas.getContext('2d');

        collisionCtx.drawImage(image, 0,0);

        const trimmedCanvas = trimCanvas(collisionCanvas);

        this.scene.textures.addCanvas('trimmed', trimmedCanvas);
        const canvasImage = new Phaser.GameObjects.Image(this.scene, 0,0,'trimmed').setOrigin(0);
        resolve(canvasImage);
      }]);
    });
  }

  doIntro () {
    ABCyaPhaser.Tweens.addTween(this.bg, 800, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }

  menuChange (cat) {
    if (this.workingCategory === cat) return;

    this.removeCurrentCategoryItems();

    this.workingScale = 1.0;
    if (cat === 'Container') {
      this.sundaePosition.yOffset = 0;
      this.scene.tweens.killTweensOf(this.itemContainer);
      ABCyaPhaser.Tweens.addTween(this.itemContainer, 1200, { x: 0,y: 0, scaleX: this.workingScale, scaleY: this.workingScale, easeParams: [2, 5] },Phaser.Math.Easing.Elastic.Out);
    }
    else if (cat === 'Flavor') {
      this.sundaePosition.yOffset = 0;
      this.scene.tweens.killTweensOf(this.itemContainer);
      ABCyaPhaser.Tweens.addTween(this.itemContainer, 1200, { x: 0,y: 0, scaleX: this.workingScale, scaleY: this.workingScale, easeParams: [2, 5] },Phaser.Math.Easing.Elastic.Out);
    }
    else if (cat === 'Sauce') {
      this.workingScale = 1;
      this.sundaePosition.yOffset = 250;
      if (this.sundaeInfo.scoops.length < 2) {
        this.sundaePosition.yOffset = 180;
      }
      this.scene.tweens.killTweensOf(this.itemContainer);
      ABCyaPhaser.Tweens.addTween(this.itemContainer, 1200, { x: 0,y: this.sundaePosition.yOffset, scaleX: this.workingScale, scaleY: this.workingScale, easeParams: [1, 2] },Phaser.Math.Easing.Elastic.Out);

      const sauceY = this.sundaePosition.top + this.sundaePosition.yOffset;
      const canLand = this.sundaeInfo.scoops.length > 0;
      this.sauceView.doIntro(this.itemContainer, sauceY, canLand, this.sundaePosition.yOffset * -1);
      if (this.topScoopContainer) {
        this.topScoopContainer.add([this.topScoopContainer.sauceLayer,this.topScoopContainer.toppingsLayer]);
        this.topScoopContainer.bringToTop(this.topScoopContainer.sauceLayer);
        this.topScoopContainer.bringToTop(this.topScoopContainer.toppingsLayer);

        if (this.sundaeInfo.containerIsDish) {
          this.topScoopContainer.add(this.containerSprite);
          this.topScoopContainer.bringToTop(this.containerSprite);
        }
      }
    }
    else if (cat === 'Whipped Cream') {
      this.sundaePosition.yOffset = 306;
      if (this.sundaeInfo.scoops.length < 2) {
        this.sundaePosition.yOffset = 236;
      }

      this.workingScale = 1;

      this.scene.tweens.killTweensOf(this.itemContainer);
      ABCyaPhaser.Tweens.addTween(this.itemContainer, 1200, { x: 0,y: this.sundaePosition.yOffset, scaleX: this.workingScale, scaleY: this.workingScale, easeParams: [2, 5] },Phaser.Math.Easing.Elastic.Out);

      const y = this.sundaePosition.top + this.sundaePosition.yOffset; // scoop
      this.whippedCream.bringCream(y, this.sundaePosition.yOffset * -1);
    }
    else if (cat === 'Toppings') {
      this.workingScale = 0.8;
      this.sundaePosition.yOffset = 125;

      this.scene.tweens.killTweensOf(this.itemContainer);
      ABCyaPhaser.Tweens.addTween(this.itemContainer, 1200, { x: this.workAreaPostions.centerX - (this.workAreaPostions.centerX * this.workingScale), y: this.sundaePosition.yOffset , scaleX: this.workingScale, scaleY: this.workingScale, easeParams: [2, 5] },Phaser.Math.Easing.Elastic.Out, () => this.setToppingStickImage());
    }
    else {
      console.log(`error handling itemenuChange workarea: ${cat}`);
    }

    ABCyaPhaser.Audio.playOneShot(`menu_${this.menuSound}`, this.scene);

    this.menuSound++;
    if (this.menuSound > 2) this.menuSound = 1;
    this.workingCategory = cat;
  }

  setToppingStickImage () {
    this.toppingThrowContainer.x = this.itemContainer.x;
    this.toppingThrowContainer.y = this.itemContainer.y;

    this.toppingThrowContainer.scaleX = this.itemContainer.scaleX;
    this.toppingThrowContainer.scaleY = this.itemContainer.scaleY;

    this.saveCurrentStickyImage();
    this.viewArea.add(this.toppingThrowContainer);
    this.viewArea.bringToTop(this.toppingThrowContainer);
    this.topScoopContainer.add([this.topScoopContainer.sauceLayer,this.topScoopContainer.toppingsLayer]);
    this.topScoopContainer.bringToTop(this.topScoopContainer.sauceLayer);
    this.topScoopContainer.bringToTop(this.topScoopContainer.toppingsLayer);

    if (this.sundaeInfo.containerIsDish) {
      this.topScoopContainer.add(this.containerSprite);
      this.topScoopContainer.bringToTop(this.containerSprite);
    }
  }

  saveCurrentStickyImage () {
    if (this.tmpImg) {
      this.tmpImg.destroy();
      this.tmpImg = null;
      this.tmpCanvas = null;
      this.tmpRt.destroy();
      this.tmpRt = null;
    }
    if (this.scene.textures.exists('tmpimg')) this.scene.textures.remove('tmpimg');
    this.containerSprite.visible = false;

    this.tmpRt = new Phaser.GameObjects.RenderTexture(this.scene, 0,0,Math.ceil(this.workAreaPostions.width),Math.ceil(this.workAreaPostions.height * 0.9));
    this.tmpRt.draw(this.viewArea, -this.workAreaPostions.left, -this.workAreaPostions.top);

    this.tmpRt.snapshot((image) => {
      const collisionCanvas = document.createElement('canvas');
      collisionCanvas.width = this.tmpRt.width;
      collisionCanvas.height = this.tmpRt.height;
      const collisionCtx = collisionCanvas.getContext('2d');

      collisionCtx.drawImage(image, 0,0);

      this.tmpCanvas = collisionCanvas;

      this.scene.textures.addCanvas('tmpimg', collisionCanvas);
      this.tmpImg = new Phaser.GameObjects.Image(this.scene,this.workAreaPostions.left, this.workAreaPostions.top, 'tmpimg').setOrigin(0);
    });

    this.containerSprite.visible = true;
  }

  selectContainer (value) {
    const prevContainer = this.sundaeInfo.container;
    let containerExisted = false;
    if (prevContainer >= 0) {
      this.tossOutItem(this.containerSprite, this.tossOutSpeed);
      containerExisted = true;
    }

    this.scoopsView.wipeScoops();
    this.sundaeInfo.container = value;
    this.sundaeInfo.containerIsDish = IceCreamData.containerIsDish[value - 1];
    this.containerSprite.setFrame(`Container+${value}`).setOrigin(0.5);
    this.containerSprite.x = this.workAreaPostions.centerX;
    const y = this.workAreaPostions.top - this.containerSprite.height / 2;
    this.containerSprite.y = y;
    const destY = this.workAreaPostions.bottom - this.containerFixedY + this.containerSprite.height / 2;
    this.containerSprite.destY = destY;
    this.scene.tweens.killTweensOf(this.containerSprite);
    ABCyaPhaser.Tweens.addTween(this.containerSprite, 1000, { y: destY }, Phaser.Math.Easing.Quadratic.Out);
    this.scene.sound.sounds.forEach((sound) => {
      if (sound.currentMarker?.name === SoundAssetKeys._slide_whistle_down) sound.setMute(true);
    });
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide_whistle_down, this.scene);
    this.sundaePosition.top = destY - this.containerSprite.height / 2;

    this.sauceView.sauce.sauceDisplayCanvas.clear();

    return !containerExisted;
  }

  selectFlavor (value) {
    const containerY = this.containerSprite.destY - this.containerSprite.height / 2 + IceCreamData.scoopBase;
    const newscoop = this.scoopsView.addScoop(value, containerY,this.sundaeInfo.containerIsDish);
    let tweentime = 0;
    if (newscoop) {
      /** @type {Phaser.GameObjects.Container} */
      const container = this.scoopContainers.getSprite();
      container.add(newscoop);
      let scoopY = containerY - (newscoop.height / 2);
      scoopY -= this.sundaeInfo.scoops.length * IceCreamData.scoopOffset / 2;
      tweentime = 800;
      ABCyaPhaser.Tweens.addTween(newscoop, tweentime, { y: scoopY, easeParams: [2,6] }, Phaser.Math.Easing.Elastic.Out);
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._appear_pop, this.scene);

      this.sundaePosition.top = scoopY - newscoop.height / 2;
      this.sundaeInfo.scoops.push(newscoop);

      this.topScoopContainer = container;
      this.topScoopContainer.name = 'TopScoopContainer';
      this.currentScoopContainers.push(container);

      this.itemContainer.add(container);

      if (this.sundaeInfo.containerIsDish) {
        this.itemContainer.add(this.containerSprite);
        this.itemContainer.bringToTop(this.containerSprite);
      }
    }
    else {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide_whistle_down, this.scene);
      this.topScoopContainer = null;
    }
    if (this.sundaeInfo.scoops.length === 1) {
      return tweentime;
    }
    else {
      return 0;
    }
  }

  selectSauce (value, color) {
    this.saveCurrentSauce();
    this.sauceView.switchSauce(value, color);
  }

  selectTopping(value) {
    this.toppings.selectTopping(value);
  }

  selectWhipping (value, color) {
    this.whippedCream.switchCream(value, color);
  }

  addToppingToTopScoop (item) {
    if (this.sundaeInfo.scoops.length <= 0) return;
    // eslint-disable-next-line no-param-reassign
    item.y += this.sundaePosition.yOffset;
    const theScoop = this.sundaeInfo.scoops[this.sundaeInfo.scoops.length - 1];
    this.topScoopContainer.toppingsLayer.add(item);
    if (this.sundaeInfo.containerIsDish) {
      this.topScoopContainer.add(this.containerSprite);
      this.topScoopContainer.bringToTop(this.containerSprite);
    }
    // eslint-disable-next-line no-param-reassign
    item.toppingType = 'topping';
    theScoop.toppingStuff.push(item);
  }

  spritesUpdate (dt) {
    let item = null;
    let len = this.extraActiveSprites.length - 1;
    for (let i = len; i >= 0; i--) {
      item = this.extraActiveSprites[i];
      const alive = item.tick(dt);
      if (alive === false) {
        this.returnExtraSprite(i);
      }
      else {
        item.update();
      }
    }

    len = this.extraActiveBitmaps.length - 1;
    for (let i = len; i >= 0; i--) {
      item = this.extraActiveBitmaps[i];
      const alive = item.tick(dt);
      if (alive === false) {
        this.returnExtraImage(i);
      }
      else {
        item.update();
      }
    }
  }

  returnExtraImage (i) {
    const p = this.extraActiveBitmaps[i];
    this.trashContainer.remove(p.bmp);
    this.extraBitmapPool.returnSprite(p);
    this.extraActiveBitmaps.splice(i,1);
  }

  returnExtraSprite (i) {
    const p = this.extraActiveSprites[i];
    this.trashContainer.remove(p);
    this.extraSpritePool.returnSprite(p);
    this.extraActiveSprites.splice(i,1);
  }

  update (dt) {
    this.sauceView.update(dt);
    this.whippedCream.update(dt);
    this.toppings.update(dt);

    this.spritesUpdate(dt);
  }
}